'use client'

import { useSEO } from '@/hooks/useSEO'

interface DynamicPageHeaderProps {
  pagePath: string
  fallbackTitle: string
  fallbackDescription: string
  titleClassName?: string
  descriptionClassName?: string
}

export default function DynamicPageHeader({ 
  pagePath, 
  fallbackTitle, 
  fallbackDescription,
  titleClassName = "text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4 uppercase leading-tight",
  descriptionClassName = "text-xs sm:text-sm md:text-base lg:text-lg text-gray-400 leading-relaxed"
}: DynamicPageHeaderProps) {
  const { pageTitle, pageDescription, isLoading } = useSEO()

  if (isLoading) {
    return (
        <div className="animate-pulse">
          <div className="h-8 bg-gray-700 rounded mb-4"></div>
          <div className="h-4 bg-gray-700 rounded w-3/4"></div>
        </div>
    )
  }

  // Sử dụng data từ admin nếu có, không thì dùng fallback
  const displayTitle = pageTitle || fallbackTitle
  const displayDescription = pageDescription || fallbackDescription

  return (
    <div className="w-full">
      <h1 className={titleClassName}>
        {displayTitle.includes(':') ? (
          <>
            <span style={{ color: 'var(--primary)' }}>
              {displayTitle.split(':')[0]}:
            </span>
            {displayTitle.split(':')[1]}
          </>
        ) : (
          <span style={{ color: 'var(--primary)' }}>{displayTitle}</span>
        )}
      </h1>
      <p className={descriptionClassName}>
        {displayDescription}
      </p>
    </div>
  )
} 